import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a0328e5f6558f001492bbed/navyatravels/src/app/admin-dashboard/components/AdminDashboardClient.tsx");
